import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["value", "onChange", "onBlur", "onFocus", "onClick", "onKeyDown", "placeholder", "label", "error", "helperText", "disabled", "startAdornment", "endAdornment", "className", "containerClassName", "customInputClass", "dataTestId", "disableLabelAnimation", "borderRadius", "height", "padding", "leftOnLabel", "id", "name", "autoComplete", "type", "showBorder"];
var __jsx = React.createElement;
import React, { forwardRef } from 'react';
import { cn } from '@lib/cn';
import APP_CONFIGURATION from '@lib/app.config';
const CustomInput = /*#__PURE__*/forwardRef((_ref, ref) => {
  var _APP_CONFIGURATION$co, _APP_CONFIGURATION$co2, _APP_CONFIGURATION$co3, _APP_CONFIGURATION$co4, _APP_CONFIGURATION$co5, _APP_CONFIGURATION$co6, _APP_CONFIGURATION$co7, _APP_CONFIGURATION$co8;
  let {
      value = '',
      onChange,
      onBlur,
      onFocus,
      onClick,
      onKeyDown,
      placeholder,
      label,
      error = false,
      helperText,
      disabled = false,
      startAdornment,
      endAdornment,
      className = '',
      containerClassName,
      customInputClass,
      dataTestId,
      disableLabelAnimation = false,
      borderRadius = (_APP_CONFIGURATION$co = APP_CONFIGURATION === null || APP_CONFIGURATION === void 0 || (_APP_CONFIGURATION$co2 = APP_CONFIGURATION.config) === null || _APP_CONFIGURATION$co2 === void 0 || (_APP_CONFIGURATION$co2 = _APP_CONFIGURATION$co2.forms) === null || _APP_CONFIGURATION$co2 === void 0 ? void 0 : _APP_CONFIGURATION$co2.borderRadius) !== null && _APP_CONFIGURATION$co !== void 0 ? _APP_CONFIGURATION$co : '12px',
      height = (_APP_CONFIGURATION$co3 = APP_CONFIGURATION === null || APP_CONFIGURATION === void 0 || (_APP_CONFIGURATION$co4 = APP_CONFIGURATION.config) === null || _APP_CONFIGURATION$co4 === void 0 || (_APP_CONFIGURATION$co4 = _APP_CONFIGURATION$co4.forms) === null || _APP_CONFIGURATION$co4 === void 0 ? void 0 : _APP_CONFIGURATION$co4.height) !== null && _APP_CONFIGURATION$co3 !== void 0 ? _APP_CONFIGURATION$co3 : '48px',
      padding = (_APP_CONFIGURATION$co5 = APP_CONFIGURATION === null || APP_CONFIGURATION === void 0 || (_APP_CONFIGURATION$co6 = APP_CONFIGURATION.config) === null || _APP_CONFIGURATION$co6 === void 0 || (_APP_CONFIGURATION$co6 = _APP_CONFIGURATION$co6.forms) === null || _APP_CONFIGURATION$co6 === void 0 ? void 0 : _APP_CONFIGURATION$co6.padding) !== null && _APP_CONFIGURATION$co5 !== void 0 ? _APP_CONFIGURATION$co5 : '12px 16px',
      leftOnLabel = (_APP_CONFIGURATION$co7 = APP_CONFIGURATION === null || APP_CONFIGURATION === void 0 || (_APP_CONFIGURATION$co8 = APP_CONFIGURATION.config) === null || _APP_CONFIGURATION$co8 === void 0 || (_APP_CONFIGURATION$co8 = _APP_CONFIGURATION$co8.forms) === null || _APP_CONFIGURATION$co8 === void 0 ? void 0 : _APP_CONFIGURATION$co8.leftOnLabel) !== null && _APP_CONFIGURATION$co7 !== void 0 ? _APP_CONFIGURATION$co7 : '12px',
      id,
      name,
      autoComplete,
      type = 'text',
      showBorder = true
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const [focused, setFocused] = React.useState(false);
  const hasValue = value.length > 0;
  const shouldShowLabel = !disableLabelAnimation && label;
  const shouldAnimateLabel = !disableLabelAnimation && (focused || hasValue);
  const handleFocus = e => {
    setFocused(true);
    onFocus === null || onFocus === void 0 || onFocus();
  };
  const handleBlur = e => {
    setFocused(false);
    onBlur === null || onBlur === void 0 || onBlur();
  };
  return __jsx("div", {
    className: cn('relative', containerClassName)
  }, __jsx("div", {
    className: cn('relative flex items-center rounded-xl transition-all duration-200', className, error && 'border-red-500 focus-within:ring-red-500', disabled && 'opacity-50 cursor-not-allowed bg-gray-50', showBorder && 'border-[0.5px] border-globals-input_border'),
    style: {
      borderRadius,
      height,
      padding
    }
  }, startAdornment && __jsx("div", {
    className: "flex items-center mr-3"
  }, startAdornment), __jsx("div", {
    className: "flex-1 relative"
  }, shouldShowLabel && __jsx("label", {
    className: cn('absolute left-0 pointer-events-none transition-all duration-200', shouldAnimateLabel ? 'top-0 transform -translate-y-1/2 scale-75 text-blue-600' : 'top-1/2 transform -translate-y-1/2 text-gray-500', 'px-1 bg-white'),
    style: {
      left: leftOnLabel
    }
  }, label), __jsx("input", _extends({
    ref: ref,
    id: id,
    name: name,
    type: type,
    value: value,
    onChange: onChange,
    onFocus: handleFocus,
    onBlur: handleBlur,
    onClick: onClick,
    onKeyDown: onKeyDown,
    placeholder: disableLabelAnimation && hasValue ? '' : placeholder || label,
    disabled: disabled,
    autoComplete: autoComplete || 'off',
    autoCorrect: "off",
    autoCapitalize: "off",
    spellCheck: "false",
    "data-testid": dataTestId,
    className: cn('w-full h-full border-none outline-none bg-transparent', 'placeholder:text-general-general_text text-general-general_text', customInputClass)
  }, props))), endAdornment && __jsx("div", {
    className: "flex items-center ml-3"
  }, endAdornment)), helperText && __jsx("p", {
    className: cn('mt-1 text-sm', error ? 'text-general-error' : 'text-general-general_text')
  }, helperText));
});
CustomInput.displayName = 'CustomInput';
export default CustomInput;